<p [ngClass]="[fontWeight, fontColor, cursorType, textDecoration, textLine]">
  <ng-content></ng-content>
</p>
